import { KeyId } from './Widgets.constants';

export const generateURL = (location, url: string) => {
  const module = location.pathname.split('/').filter(Boolean)?.[0];
  const pathname = `/${module}/${url}`;
  const Id = new URLSearchParams(location.search)?.get(KeyId[module]?.id);

  const params = new URLSearchParams({ [KeyId[module]?.id]: Id });

  return `${pathname}?${params.toString()}`;
};
